import { Button, Layout, Space, theme, Typography } from "antd";
import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { IoAddSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import routes from "../../../engine/routes";
import { getPrincipals } from "../Slices/Principals.slice";
import CustomTable from "../../../shared/components/CustomTable";
import { columnsPrincipalsList } from "./PrincipalsListForms";
import { AlignCenterEnd } from "../../../shared/components/AlignCenterEnd/AlignCenterEnd";

const { Content, Sider, Header, Footer } = Layout;

export function Principalslist(props) {
  const { principals, loading } = useSelector(state => state.principals);
  const dispatch = useDispatch();

  // const context = useContext(AppContext);
  const {
    token: { colorBgLyout },
  } = theme.useToken();

  useEffect(() => {
    dispatch(getPrincipals());
  }, []);

  return (
    <Content>
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          {routes.principals().title}
        </Typography.Title>
        <Link to={routes.principals().new.path}>
          <Button
            size={"large"}
            type={"primary"}
            style={{ justifySelf: "flex-start", display: "flex" }}
            icon={<IoAddSharp style={{ marginTop: "0px" }} size={25} />}
          >
            {routes.principals().new.title}
          </Button>
        </Link>
      </Space>

      <br />
      <CustomTable
        smTitle={item => {
          return (
            <div className={"alignHeaderPage"}>
              <h2 className={"noMargin"}>{item.name}</h2>
            </div>
          );
        }}
        loading={loading}
        onRowLink={record => routes.principals(record._id).detail.path}
        hasPagination={true}
        dataSource={principals}
        columns={columnsPrincipalsList}
        rowKey="_id"
      />
    </Content>
  );
}
